import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { CircularProgress } from '@material-ui/core'
import { Page, Header, CustomTable } from 'components'
import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import { useAuth } from 'hooks/useAuth'
import useRouter from 'utils/useRouter'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import VisibilityIcon from '@material-ui/icons/Visibility'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import { criarAlerta } from 'actions'
import { DetailPanel } from './DetailPanel'
import { FiltrosBancoExames } from './FiltrosBancoExames'

import useStyles from './styles'

export const BancoDeExames = (props) => {
  const { route } = props
  const router = useRouter()
  const { currentUser } = useAuth()
  const exameRealizadoService = useExameRealizadoService()
  const dispatch = useDispatch()
  moment.locale('pt-br', localization)
  const [exames, setExames] = useState([])
  const [processandoExames, setProcessandoExames] = useState(false)
  const [processandoDocumento, setProcessandoDocumento] = useState(false)
  const classes = useStyles()

  const handleClickVisualizarPagina = (rowData) => {
    router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${rowData.exSol.id}`)
  }

  const handleDownloadDocumento = async (exameRealizado) => {
    try {
      await exameRealizadoService.downloadArquivoDocumento(exameRealizado.id, exameRealizado.numeroExame, setProcessandoDocumento)
    } catch (err) {
      if (err.response && err.response.status === 403) {
        dispatch(
          criarAlerta({
            status: 403,
            data: { error: { innerError: { message: 'Você não tem permissão para realizar o download deste documento.' } } }
          })
        )
      } else {
        dispatch(criarAlerta(err.response || err))
      }
    }
  }

  const verificarUsuarioExaminadorExameRealizado = (usuario, rowData) => {
    let result = false
    if (rowData && rowData.exSol && rowData.exSol.usuarioExaminador) {
      if (usuario.id === rowData.exSol.usuarioExaminador.id) {
        result = true
      }
    }
    return result
  }

  const verificarDisableDownloadButton = (rowData) => {
    if (verificarUsuarioExaminadorExameRealizado(currentUser, rowData)) {
      return false
    }

    if (rowData && rowData.status === 'Publicado') {
      return false
    }
    return true
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      <FiltrosBancoExames setExames={setExames} setProcessandoExames={setProcessandoExames} />
      {processandoExames ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <CustomTable
          searchPlaceholder="Buscar exames..."
          localization={{
            body: {
              emptyDataSourceMessage: 'Nenhum exame encontrado',
            },
          }}
          columns={[
            {
              title: 'Identificador',
              field: 'numeroExame',
            },
            {
              title: 'Tipo',
              field: 'exSol.tipoEx.nome',
              emptyValue: '-',
            },
            {
              title: 'Data da criação do documento',
              render: (rowData) => moment(rowData.exSol.createdAt).format('LLLL'),
            },
            {
              title: 'Status',
              field: 'status',
            },
          ]}
          detailPanel={(rowData) => <DetailPanel idExameSelecionado={rowData.id} />}
          onRowClick={(event, rowData, togglePanel) => togglePanel()}
          data={exames}
          actions={[
            {
              icon: VisibilityIcon,
              tooltip: 'Visualizar página do exame',
              onClick: (event, rowData) => handleClickVisualizarPagina(rowData),
            },
            (rowData) => ({
              icon: CloudDownloadIcon,
              disabled: verificarDisableDownloadButton(rowData) || processandoDocumento,
              tooltip: 'Download do documento',
              onClick: (event, rowData) => handleDownloadDocumento(rowData),
            }),
          ]}
          options={{
            pageSize: 20,
          }}
        />
      )}
    </Page>
  )
}
